import React, { Component } from 'react';
import './ec2ExSidebar.css';
import Ec2ExSidebarButton from './ec2ExSidebarButton/ec2ExSidebarButton.js';

class Ec2ExSidebar extends Component {

  state = {

  };

  componentDidMount() {

  };

  render() {

    return (
      <div className="Ec2ExSidebarPage">
        {this.props.headers.slice(1).map(header => {
          return <Ec2ExSidebarButton key={header.title} header={header} toggleColumnVisibility={this.props.toggleColumnVisibility}/>;
        })}
      </div>
    );

  };

};

export default Ec2ExSidebar;


// WEBPACK FOOTER //
// ./src/components/content/ec2Explorer/ec2ExSidebar/ec2ExSidebar.js